import { InfraIoError } from './errors';
import type { CheckoutOptions } from './types';

export function openRedirect(
  publicKey: string,
  checkoutBaseURL: string,
  options: CheckoutOptions,
): void {
  const returnUrl = window.location.href;

  // options.checkoutUrl (from API response checkout_url) takes priority —
  // makes redirect mode work across dev/prod without extra config.
  const checkoutPageURL =
    options.checkoutUrl ?? `${checkoutBaseURL}/${encodeURIComponent(options.sessionId)}`;

  // Use URL to safely merge params — checkoutPageURL may already contain a query
  // string from the API (e.g. "?session_token=..."). Naive string concat would
  // produce "...?foo=bar?pk=..." which is invalid.
  let urlObj: URL;
  try {
    urlObj = new URL(checkoutPageURL);
  } catch {
    throw new InfraIoError('invalid_request_error', `Invalid checkoutUrl: ${checkoutPageURL}`);
  }
  urlObj.searchParams.set('pk', publicKey);
  urlObj.searchParams.set('return_url', returnUrl);

  window.location.href = urlObj.toString();
}
